import * as React from 'react';

import './breadcrumb-item.css';

interface BreadcrumbItemProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  isActive: boolean;
}

const BreadcrumbItem = React.forwardRef<HTMLDivElement, BreadcrumbItemProps>(
  ({ label, isActive, ...props }, ref) => {
    return (
      <div
        className={`breadcrumb-item ${isActive ? 'active-bci' : ''}`}
        ref={ref}
        {...props}
      >
        {label}
      </div>
    );
  },
);

export { BreadcrumbItem };
